import React, { useEffect, useState } from "react";
import { fetchJson, post } from "../../lib/Fetching";
import Button from "../Button";
import Select from "react-select";
import NotificationMechanismsSelect from "./NotificationMechanismsSelect";
import PeopleSelect from "./PeopleSelect";
import CompanyBranchesSelect from "./CompanyBranchesSelect";
import TestingCategoriesSelect from "./TestingCategoriesSelect";
import ProductsSelect from "./ProductsSelect";
import TechniquesSelect from "./TechniquesSelect";
import MatricesSelect from "./MatricesSelect";
import { MinimalContainer } from "../sample_reporting/Theme";
import styled, { css } from "styled-components";
import Checkbox from "../common/form/Checkbox";
import QualifierInput from "../common/form/QualifierInput";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const Container = styled(MinimalContainer)`
  padding: 20px;
  max-width: 1920px;
  margin: 0 auto;
`;

export default function NotificationGroupForm({ newGroup, handleGroupSubmit, clientView }) {
  const [group, setGroup] = useState(newGroup);

  const handleSubmit = (e) => handleGroupSubmit(group);

  const handleSelectChange = (name) => (options) =>
    setGroup({
      ...group,
      [name]: Array.isArray(options) ? options.map((i) => i.value) : [options.value],
    });

  const company_id = group.company_id;

  return (
    <Container>
      <div className="panel-body">
        <div className="row">
          <div className="col-md-4">
            <label>Name</label>
            <input
              type="text"
              name="name"
              className="form-control"
              placeholder="Group Name here..."
              onChange={(e) =>
                setGroup({
                  ...group,
                  name: e.target.value,
                })
              }
              value={group.name}
              style={{ width: "100%", marginBottom: "6px" }}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <label>Select Testing Categories</label>
            <TestingCategoriesSelect
              handleSelectChange={handleSelectChange("testing_category_ids")}
              company_id={company_id}
              testing_category_ids={group.testing_category_ids}
            />
          </div>
          <div className="col-md-4">
            <label>Select Matrices</label>
            <MatricesSelect
              handleSelectChange={handleSelectChange("matrix_ids")}
              company_id={company_id}
              matrix_ids={group.matrix_ids}
            />
          </div>

          <div className="col-md-4">
            <label>Select Techniques</label>
            <TechniquesSelect
              technique_ids={group.technique_ids}
              handleSelectChange={handleSelectChange("technique_ids")}
              company_id={company_id}
            />
          </div>
        </div>

        <div className="row" style={{ marginTop: 20 }}>
          <div className="col-md-6" style={{ marginTop: "10px" }}>
            <div
              style={{
                border: "1px solid #AAA",
                borderRadius: 10,
                padding: 10,
                paddingTop: 30,
                minHeight: 85,
                textAlign: "center",
              }}
            >
              <label style={{ marginRight: 30 }}>
                <Checkbox
                  checked={group.include_failed_results}
                  onChange={(e) =>
                    setGroup({
                      ...group,
                      include_failed_results: e.target.checked,
                      include_detected_results: false,
                    })
                  }
                />
                &nbsp;&nbsp;
                {I18n.t("include_failed_results")}
              </label>

              <label style={{ marginRight: 30 }}>
                <Checkbox
                  checked={group.include_warning_results}
                  onChange={(e) =>
                    setGroup({
                      ...group,
                      include_warning_results: e.target.checked,
                      include_detected_results: false,
                    })
                  }
                />
                &nbsp;&nbsp;
                {I18n.t("include_warning_results")}
              </label>
              <label style={{ marginRight: 30 }}>
                <Checkbox
                  checked={group.include_detected_results}
                  onChange={(e) =>
                    setGroup({
                      ...group,
                      include_detected_results: e.target.checked,
                      include_warning_results: false,
                      include_failed_results: false,
                    })
                  }
                />
                &nbsp;&nbsp;
                {I18n.t("include_detected_results")}
              </label>
            </div>
          </div>
          <div
            className="col-md-1"
            style={{ textAlign: "center", paddingTop: 30, fontSize: 18 }}
          >
            OR
          </div>
          <div className="col-md-5" style={{ marginTop: "10px" }}>
            <div style={{ border: "1px solid #AAA", borderRadius: 10, padding: 10 }}>
              <label>With One of these Qualifiers...</label>
              <QualifierInput
                value={group.qualifier_ids}
                onChange={(ids) =>
                  setGroup({
                    ...group,
                    qualifier_ids: ids,
                  })
                }
              />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <br />
            <Button primary onClick={handleSubmit} title={I18n.t("save")} />
            {group.id && (
              <div className="alert alert-warning" style={{ marginBottom: 0, marginTop: 20 }}>
                WARNING: Any changes you make to test parameters will only apply to new
                results, or results added since the 'Results Processed Up To' date above.
              </div>
            )}
          </div>
        </div>
      </div>
    </Container>
  );
}
